module.exports = __webpack_public_path__ + "img/bg-intro@2x.5599fd8a.png";